import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useCurrentPage from "../../../../hooks/useCurrentPage";
import axios from "axios";
import MainServices from "../../../../services/MainServices";
import moment from "moment";
import PageLoader from "../../../../assets/loaders/PageLoading";
import ApprovalStatusModal from "../../../../assets/modal/ApprovalStatusModal";
import { notifySuccess, notifyWarn } from "../../../../assets/elements/Toast";
import { Button, Modal } from "react-bootstrap";
import "./BranchDetails.scss";
import editicon from "../../../../assets/images/icons/edit.svg";
import PermissionFunctions from "../../../../assets/functions/PermissionFunctions";
import { Formik } from "formik";
import useAuth from "../../../../hooks/useAuth";
import useFeatureSetting from "../../../../hooks/useFeatureSetting";
import { Form } from "react-bootstrap";
import { PrimaryInput } from "../../../../assets/FormElements";
import CustomErrorMessage from "../../../../assets/elements/ErrorMessage";
import { squareBackIcon, backarrowicon } from "../../../../assets/images/icons/icons";
import ButtonLoading from "../../../../assets/loaders/ButtonLoading";
import * as Yup from "yup";
import Cross from "../../../../assets/images/icons/cross.svg";
import IsWorkflowSlug from "../../../../assets/modal/IsWorkflowSlug";
import Workflows from "../../../../assets/workflows/Workflows";
import WorkflowHistory from "../../../../assets/workflows/WorkflowHistory";
import CustomDigitalSignature from "../../../../assets/modal/CustomDigitalSignature";

const BranchDetails = () => {
  const { user } = useAuth();
  const { grantPermission } = PermissionFunctions();
  const { updateCurrentPage } = useCurrentPage();
  const {
    getBranchById,
    updateEventWorkflowReview,
    getEventWorkflowById,
    updateBranchMaster,
    getWorkflowsBySlug,
  } = MainServices();
  const [pageLoading, setPageLoading] = useState(0);
  const [branches, setBranches] = useState([]);
  const [workflowMasters, setWorkflowMasters] = useState({});
  const location = useLocation();
  const [approvedLoading, setApprovedLoading] = useState(0);
  const [approvedModal, setApprovedModal] = useState(false);
  const [digitalSignatureModal, setDigitalSignatureModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState({});
  const [addBranchModal, setAddBranchModal] = useState(false);
  //url Params
  const publicId = new URLSearchParams(location.search).get("publicId");
  const refId = new URLSearchParams(location.search).get("refId");
  const workflowConcurrencystamp = new URLSearchParams(location.search).get(
    "workflowConcurrencystamp"
  );
  const { updateSettingContext, setting } = useFeatureSetting();
  const [buttonLoading, setButtonLoading] = useState(0);
  const [intiLoading, setIntiLoading] = useState(0);
  const [workflowAssign, setWorkflowAssign] = useState({});
  const edit = new URLSearchParams(location.search).get("edit");
  const [editInitiated, setEditInitiated] = useState(false);
  const [isWorkflowFlag, setIsWorkflowFlag] = useState({});
  const [workflowDataSet, setWorkflowDataSet] = useState("");
  const [workflowModal, setWorkflowModal] = useState(false);
  const [isStatusUpdate, setIsStatusUpdate] = useState(0);
  const [reinitiateClicked, setReinitiateClicked] = useState(false);

  const branchSchema = Yup.object().shape({
    branchName: Yup.string()
      .transform((value) => value.trim())
      .matches(
        /^[a-zA-Z0-9\s]*$/,
        "Branch Name cannot contain special characters"
      )
      .required("Branch Name is Required"),
    branchDescription: Yup.string()
      .transform((value) => value.trim())
      .required("Branch Description is Required"),
    branchCode: Yup.string()
      .transform((value) => value.trim())
      .required("Branch Code is Required"),
  });

  const schemaOfWorkflow = Yup.object().shape({
    branchName: Yup.string()
      .transform((value) => value.trim())
      .matches(
        /^[a-zA-Z0-9\s]*$/,
        "Branch Name cannot contain special characters"
      )
      .required("Branch Name is Required"),
    branchDescription: Yup.string()
      .transform((value) => value.trim())
      .required("Branch Description is Required"),
    branchCode: Yup.string()
      .transform((value) => value.trim())
      .required("Branch Code is Required"),
    workflows: Yup.array()
      .of(
        Yup.object().shape({
          users: Yup.array().required("users array is required"),
        })
      )
      .test("at-least-one-user", "Workflow is Required", function (workflows) {
        return workflows.some(
          (workflow) => workflow.users && workflow.users.length > 0
        );
      }),
  });

  useEffect(() => {
    updateCurrentPage({
      title: "Branch",
      subtitle: "Details",
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateSettingContext("branches");
  }, []);

  useEffect(() => {
    if (publicId) {
      getBranchMasterByStatus();
      getIsWorkflowSlug();
    }
    // eslint-disable-next-line
  }, [publicId]);

  useEffect(() => {
    if (refId) {
      getWorkflowById();
    }
    // eslint-disable-next-line
  }, [refId]);

  const getBranchMasterByStatus = async () => {
    setPageLoading(true);
    const details = {};

    await axios
      .all([getBranchById(details, publicId)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let branches = resData.data ? resData.data : {};
            setBranches(branches);
            if (edit === "true" && !editInitiated) {
              onAddBranch(branches);
              setEditInitiated(true);
            }
            setPageLoading(false);
          } else {
            setPageLoading(false);
          }
        } else {
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        if (res.message)
          console.log("An error occurred in getting Departments");
      });
  };

  const getWorkflowById = async () => {
    setPageLoading(true);
    const details = {
      filters: [{ key: "publicId", eq: refId }],
      sorting: [{ key: "id", direction: "asc" }],
    };

    await axios
      .all([getEventWorkflowById(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let workflows = resData.data ? resData.data : [];
            setWorkflowMasters(workflows[0]);
            setPageLoading(false);
          } else {
            setPageLoading(false);
          }
        } else {
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        if (res.message)
          console.log("An error occurred in getting Event Workflow");
      });
  };

  const getIsWorkflowSlug = async () => {
    const details = {};
    await axios
      .all([getWorkflowsBySlug(details)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let isWorkflow = resData?.data ? resData?.data : {};
            isWorkflow = isWorkflow?.content
              ? JSON.parse(isWorkflow?.content)
              : {};
            setIsWorkflowFlag(isWorkflow);
          } else {
          }
        } else {
        }
      })
      .catch(function (res) {
        if (res.message)
          console.log("An error occurred in getting measurement types");
      });
  };

  const updateWorkflowStatus = async (values) => {
    setApprovedLoading(true);
    const details = {
      workflowStatus: values.status?.value,
      //   email: values.user_id,
      ...(values?.password && { password: values.password }),
      comments: values.comment,
    };
    await axios
      .all([
        updateEventWorkflowReview(details, refId, workflowConcurrencystamp),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            notifySuccess("Status changed successfully");
            setIsStatusUpdate(Math.random());
            setApprovedLoading(false);
            onApprovedStatusModal();
            getBranchMasterByStatus();
            getWorkflowById();
            // getSopWorkflows();
          } else {
            message && notifyWarn(message);
            setApprovedLoading(false);
          }
        } else {
          setApprovedLoading(false);
        }
      })
      .catch(function (res) {
        if (res.message) console.log("An error occurred in status update");
      });
  };

  const updateBranch = async (values) => {
    setButtonLoading(true);
    let workflowInfo = values?.workflows || [];
    let workflowFlag = false;
    workflowInfo =
      workflowInfo.length > 0
        ? workflowInfo.map((each) => ({
            ...each,
            users: each?.users?.map((user) => {
              workflowFlag = true;
              return {
                value: user?.publicId,
              };
            }),
            ...(each?.no_of_approvals
              ? { no_of_approvals: each?.no_of_approvals }
              : {
                  no_of_approvals: each?.users && each?.users.length,
                }),
          }))
        : [];
    const details = {
      branchName: values.branchName,
      branchDescription: values.branchDescription,
      branchCode: values.branchCode,
      ...(values?.remark && { remark: values?.remark }),
      ...(values?.password && { password: values?.password }),
    };
    if (workflowFlag) {
      details.workflowInfo = workflowInfo;
    }
    await axios
      .all([
        updateBranchMaster(
          details,
          selectedBranch.publicId,
          selectedBranch.concurrencyStamp
        ),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            getBranchMasterByStatus();
            setAddBranchModal(false);
            setDigitalSignatureModal(false);
            values?.status === "approved" && navigate(-1);
            setSelectedBranch("");
            notifySuccess("Branch Master Updated Successfully");
            setButtonLoading(false);
          } else {
            message && notifyWarn(message);
            setButtonLoading(false);
          }
        } else {
          setButtonLoading(false);
        }
      })
      .catch(function (res) {
        if (res.message)
          console.log("An error occurred in updating Branch Master");
      });
  };

  const updateBranchIntiated = async (values) => {
    setIntiLoading(true);
    const details = {
      branchName: values.branchName,
      branchDescription: values.branchDescription,
      branchCode: values.branchCode,
      ...(values?.password && { password: values?.password }),
      reinitiateWorkflowAssignId: workflowAssign.publicId,
      status: "reinitiated",
    };
    await axios
      .all([
        updateBranchMaster(
          details,
          selectedBranch.publicId,
          selectedBranch.concurrencyStamp
        ),
      ])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          let message = resData?.message;
          if (resData.success) {
            // getSopWorkflows();
            onAddBranch();
            getBranchMasterByStatus();
            setReinitiateClicked(false);
            setDigitalSignatureModal(false);
            setIsStatusUpdate(Math.random());
            notifySuccess("Branch Master Updated Successfully");
            setIntiLoading(false);
          } else {
            message && notifyWarn(message);
            setIntiLoading(false);
          }
        } else {
          setIntiLoading(false);
        }
      })
      .catch(function (res) {
        if (res.message)
          console.log("An error occurred in updating Branch Master");
      });
  };
  //functions
  const onDigitalSignatureModal = () => {
    setDigitalSignatureModal(!digitalSignatureModal);
  };

  const handleWorkflowAssignUpdate = (updatedWorkflowAssign) => {
    setWorkflowAssign(updatedWorkflowAssign);
  };

  const onManageWorkflow = ({ values, setFieldValue }) => {
    setWorkflowDataSet({
      workflows: values?.workflows,
      setFieldValue,
    });
    setWorkflowModal((prev) => !prev);
  };

  const onApprovedStatusModal = () => {
    setApprovedModal(!approvedModal);
  };

  const onAddBranch = (selected) => {
    if (selected) {
      setSelectedBranch(selected);
    } else {
      setSelectedBranch("");
    }
    setAddBranchModal(!addBranchModal);
  };

  const navigate = useNavigate();
  return (
    <div className="training-sop-main">
      <div className="admin-popular-main lims-details-page tms-inventory-details-page">
        <div className="details-page-toolbar">
          <div className="details-page-toolbar__left">
            <button
              type="button"
              className="btn btn-link details-page-back-btn"
              onClick={() => navigate(-1)}
              title="Back"
              aria-label="Go back"
            >
              {backarrowicon}
            </button>
            <div className="details-page-title-block">
              <p className="content-header-main mb-0">Branch Details</p>
            </div>
          </div>
          <div className="details-page-toolbar__right">
            {grantPermission("Branch_update") &&
              (branches.status === "approved" ||
                branches?.status === "rejected") &&
              branches.recordStatus === "active" && (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => onAddBranch(branches)}
                >
                  <img src={editicon} alt="Edit icon" />
                </div>
              )}
            {refId && workflowMasters?.workflowStatus === "pending" && (
              <Button className="details-page-action-btn theme-btn-main" onClick={onApprovedStatusModal}>Update Status</Button>
            )}
          </div>
        </div>
        {pageLoading ? (
          <PageLoader />
        ) : branches ? (
          <div className="details-page-content">
            <div className="details-card">
              <div className="details-card__header">
                <h3 className="details-card__title">Overview</h3>
              </div>
              <div className="details-grid">
                <div className="details-grid__item">
                  <div className="details-grid__label">Name</div>
                  <div className="details-grid__value">{branches?.branchName}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Description</div>
                  <div className="details-grid__value">{branches?.branchDescription}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Code</div>
                  <div className="details-grid__value">{branches?.branchCode}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Created At</div>
                  <div className="details-grid__value">{moment(branches?.createdAt).format("DD-MM-YYYY")}</div>
                </div>
                <div className="details-grid__item">
                  <div className="details-grid__label">Status</div>
                  <div className="details-grid__value">
                    {branches?.status === "approved"
                      ? branches?.recordStatus
                      : branches?.status}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="no-data-found-main">No Branch Found</div>
        )}

        <Workflows
          publicId={publicId}
          isStatusUpdate={isStatusUpdate}
          onWorkflowAssignUpdate={handleWorkflowAssignUpdate}
          initiator={branches?.createdBy?.empName}
        />

        <WorkflowHistory publicId={publicId} isStatusUpdate={isStatusUpdate} />
      </div>

      <Modal
        centered
        show={addBranchModal}
        onHide={onAddBranch}
        className="add-department-modal-main"
        size="lg"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            {selectedBranch && selectedBranch?.publicId
              ? "Update Branch"
              : "Add Branch"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-department-modal-body">
          <p className="mb-4 add-department-modal-content-text">
            Please enter branch name, description and code for branch
            Modification.
          </p>
          <Formik
            initialValues={{
              branchName: selectedBranch?.branchName || "",
              branchDescription: selectedBranch?.branchDescription || "",
              branchCode: selectedBranch?.branchCode || "",
              workflow_name: selectedBranch?.name || "",
              workflows: selectedBranch?.workflowData || [
                {
                  workflow: "reviewer",
                  users: [],
                  no_of_approvals: "",
                },
                {
                  workflow: "approver",
                  users: [],
                  no_of_approvals: "",
                },
              ],
              disabled:
                selectedBranch?.disabled === false ||
                selectedBranch?.disabled === "No"
                  ? true
                  : false,
            }}
            validationSchema={
              setting?.workflow_required === "true"
                ? schemaOfWorkflow
                : branchSchema
            }
            onSubmit={(values) => {
              if (setting.digital_signature) {
                setSelectedBranch({ ...selectedBranch, ...values });
                onDigitalSignatureModal();
              } else {
                updateBranch(values);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              dirty,
            }) => (
              <Form className="form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label" for="contact_number">
                    Branch Name
                    <span className="required-star"> *</span>
                  </label>
                  <PrimaryInput
                    placeholder="Enter Branch Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.branchName}
                    name="branchName"
                    id="branchName"
                  />
                  <CustomErrorMessage
                    name="branchName"
                    errors={errors}
                    touched={touched}
                  />
                </div>

                <div className="form-group mt-3">
                  <label className="form-label" for="contact_number">
                    Branch Description
                    <span className="required-star"> *</span>
                  </label>
                  <textarea
                    className="form-control employee-custom-form-control"
                    placeholder="Enter Branch Description"
                    aria-label="With textarea"
                    name="branchDescription"
                    id="branchDescription"
                    value={values.branchDescription}
                    onChange={handleChange}
                  ></textarea>
                  <CustomErrorMessage
                    name="branchDescription"
                    errors={errors}
                    touched={touched}
                  />
                </div>

                <div className="form-group mt-3">
                  <label className="form-label" for="contact_number">
                    Branch Code
                    <span className="required-star"> *</span>
                  </label>
                  <PrimaryInput
                    placeholder="Enter Branch Code"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.branchCode}
                    name="branchCode"
                    id="branchCode"
                  />
                  <CustomErrorMessage
                    name="branchCode"
                    errors={errors}
                    touched={touched}
                  />
                </div>

                {isWorkflowFlag &&
                  isWorkflowFlag?.standard_workflow === "false" &&
                  setting?.workflow_disabled === "false" &&
                  selectedBranch?.status === "approved" && (
                    <>
                      <div
                        className="my-4"
                        style={{ borderBottom: "1px dashed #000" }}
                      />
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0" style={{ fontWeight: 500 }}>
                          Manage Workflow :
                          {setting?.workflow_required === "true" && (
                            <span style={{ color: "#f00" }}> *</span>
                          )}
                        </p>
                        <Button
                          className="theme-btn-main"
                          style={{ padding: "11px 12px" }}
                          onClick={() =>
                            onManageWorkflow({
                              values,
                              setFieldValue,
                            })
                          }
                        >
                          Manage Workflow
                        </Button>
                      </div>
                      <div className="workflows-list">
                        {values.workflows &&
                          values.workflows.length > 0 &&
                          values.workflows.map((each_work, index) => {
                            // Generate the options array for the number of approvals
                            const options = Array.from(
                              {
                                length:
                                  each_work?.users &&
                                  each_work?.users.length > 0 &&
                                  each_work?.users.length,
                              },
                              (_, i) => ({
                                label: `${i + 1}`,
                                value: i + 1,
                              })
                            );

                            return (
                              <div className="each-work-flow mt-3" key={index}>
                                <div className="d-flex justify-content-between">
                                  <div className="workflow-head">
                                    <span
                                      style={{
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {each_work.workflow}
                                    </span>
                                  </div>
                                  <div className="form-group mb-1 d-flex gap-2 align-items-center">
                                    <label
                                      className="form-label mb-0"
                                      htmlFor="category"
                                    >
                                      {`Select Number of ${each_work.workflow}`}
                                      <span style={{ color: "#f00" }}> *</span>
                                    </label>
                                    <div className="form-control-wrap">
                                      <select
                                        className="sop-custom-form-select"
                                        id={`workflows.${index}.no_of_approvals`}
                                        name={`workflows.${index}.no_of_approvals`}
                                        placeholder="Select"
                                        onChange={(option) => {
                                          setFieldValue(
                                            `workflows.${index}.no_of_approvals`,
                                            option?.target.value
                                          );
                                        }}
                                        onBlur={handleBlur}
                                        style={{
                                          width: "100px",
                                          fontSize: "12px",
                                          padding: "6px",
                                        }}
                                      >
                                        <option>Select...</option>
                                        {options &&
                                          options?.length > 0 &&
                                          options.map((option) => {
                                            return (
                                              <option value={option.value}>
                                                {option.label}
                                              </option>
                                            );
                                          })}
                                      </select>
                                      <CustomErrorMessage
                                        name={`noOfApprovals_${index}`}
                                        errors={errors}
                                        touched={touched}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="users mt-2 px-3">
                                  {each_work.users &&
                                    each_work.users.length > 0 &&
                                    each_work.users.map((user, subI) => (
                                      <div
                                        className="each-user d-flex justify-content-between mt-2"
                                        key={subI}
                                      >
                                        <div>
                                          <span>{subI + 1}.</span>
                                          <span
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {user.label}
                                          </span>
                                        </div>
                                        <div>
                                          <img
                                            alt="Cross"
                                            src={Cross}
                                            className="delete-topic"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              let data =
                                                values?.workflows || [];
                                              let users =
                                                data[index].users || [];
                                              users = users.filter(
                                                (each, i) => subI !== i
                                              );
                                              data[index].users = users;
                                              setFieldValue("workflows", data);
                                              setFieldValue(
                                                `workflows.${index}.no_of_approvals`,
                                                ""
                                              );
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                      {/* {values.workflows &&
                                values.workflows.length > 0 &&
                                values.workflows[0]?.users &&
                                values.workflows[0]?.users.length === 0 && (
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "200px",
                                      height: "200px",
                                      backgroundColor: "white",
                                      padding: "5px",
                                    }}
                                  >
                                    Will Appear Here
                                  </div>
                                )} */}
                    </>
                  )}

                {!digitalSignatureModal && (
                  <div className="mt-3">
                    <div className="d-flex gap-2">
                      <Button
                        className="back-icon-btn-main"
                        onClick={onAddBranch}
                      >
                        <span>{squareBackIcon}</span>
                        <span className="ms-2">Back</span>
                      </Button>
                      <Button
                        className="theme-btn-main"
                        type="submit"
                        disabled={!dirty}
                      >
                        {buttonLoading ? <ButtonLoading /> : "Submit"}
                      </Button>
                      {selectedBranch?.status === "rejected" && (
                        <Button
                          className="theme-btn-main"
                          onClick={() => {
                            if (setting.digital_signature) {
                              setSelectedBranch((prev) => ({
                                ...prev,
                                ...values,
                              }));
                              onDigitalSignatureModal();
                              setReinitiateClicked(true);
                            } else {
                              updateBranchIntiated(values);
                            }
                          }}
                          disabled={!dirty}
                          // onClick={() => {
                          //   updateBranchIntiated(values);
                          // }}
                        >
                          {intiLoading ? (
                            <ButtonLoading />
                          ) : selectedBranch ? (
                            "Submit & Reinitiate"
                          ) : (
                            ""
                          )}
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <Modal
        centered
        show={approvedModal}
        onHide={onApprovedStatusModal}
        className="add-department-modal-main"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            Update Status
          </Modal.Title>
        </Modal.Header>

        {approvedModal && (
          <Modal.Body className="add-department-modal-body">
            <ApprovalStatusModal
              statusApiFunction={updateWorkflowStatus}
              onClose={onApprovedStatusModal}
              loading={approvedLoading}
            />
          </Modal.Body>
        )}
      </Modal>

      <Modal
        centered
        show={workflowModal}
        onHide={() => onManageWorkflow({})}
        className="add-department-modal-main"
        size="xl"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            Manage Workflow
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="add-department-modal-body">
          <IsWorkflowSlug
            onManageWorkflow={() => onManageWorkflow({})}
            workflowDataSet={workflowDataSet}
          />
        </Modal.Body>
      </Modal>

      <Modal
        centered
        show={digitalSignatureModal}
        onHide={onDigitalSignatureModal}
        className="add-department-modal-main"
        size="md"
      >
        <Modal.Header closeButton className="add-department-modal-header">
          <Modal.Title className="add-department-modal-title">
            E - Signature
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="add-department-modal-body">
          <CustomDigitalSignature
            digitalSignatureHandleSubmit={
              reinitiateClicked ? updateBranchIntiated : updateBranch
            }
            onDigitalSignatureModal={onDigitalSignatureModal}
            values={selectedBranch}
            isLoading={reinitiateClicked ? intiLoading : buttonLoading}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BranchDetails;
